"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { ChatProvider } from "./chat-provider";
import { ChatWidgetButton } from "./chat-widget-button";
import { ChatWidgetPanel } from "./chat-widget-panel";
export function ChatWidget() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><ChatProvider><ChatWidgetPanel /><ChatWidgetButton /></ChatProvider></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}